import { SUPPORTED_YEARS } from '../../../../../constnats/generalConstants';
import KeyValue from '../../../../../structures/keyValePair';
import ScaleUtil from '../../../../../utils/scaleUtil';
import {
    PERIODS,
    VERSIONS,
    FORMATS,
    COLUMN_TYPES,
    ROW_TYPES,
    MODE_LABEL,
    FINANCIAL_SOURCES,
    FINANCIAL_SOURCE_LABEL,
    FINANCIAL_SOURCE,
    COLUMN_TYPE,
    ROW_TYPE,
} from '../../constants/generalConstants';
import { ColContentType, RowContentType } from '../../types';

export const SUPPORTED_FIELD_VALUES = {
    YEARS: SUPPORTED_YEARS.map((year) => Number(year)).sort((a, b) => b - a),
    PERIODS: PERIODS,
    VERSIONS: VERSIONS,
    FORMATS: FORMATS,
    SCALES_KVP: ScaleUtil.scalePairs.filter((p) => p.key !== 0),
    COLUMN_TYPES,
    ROW_TYPES,
    TABLE_MODES: Object.entries(MODE_LABEL).map(([key, value]) => new KeyValue(key, value)),
    FINANCIAL_SOURCES_KVP: FINANCIAL_SOURCES.filter((x) => x !== FINANCIAL_SOURCE.NA).map(
        (source) => new KeyValue(source, FINANCIAL_SOURCE_LABEL[source])
    ),
};

export const UNSUPPORTED_FOR_IMPORT_COLUMN_TYPES: ColContentType[] = [
    COLUMN_TYPE.CHANGE,
    COLUMN_TYPE.EMPTY,
    COLUMN_TYPE.NOTES,
    COLUMN_TYPE.OTHER,
];

export const UNSUPPORTED_FOR_IMPORT_ROW_TYPES: RowContentType[] = [
    ROW_TYPE.EMPTY,
    ROW_TYPE.TABLE_HEADER
]
